import ModuleLayout from './ModuleLayout.vue';

export default ModuleLayout;



// WEBPACK FOOTER //
// ./src/components/parts/modules/modulelayout/index.ts